/**
 * Application Constants
 * Centralized location for all magic strings and configuration values
 */

// User IDs
export const GUEST_USER_ID = 'guest_user';
export const DEFAULT_USER_ID = 'default_user'; // Legacy, use GUEST_USER_ID for new code

// File Upload Limits
export const MAX_FILE_SIZE_MB = 25;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain'
];
export const ALLOWED_FILE_EXTENSIONS = ['.pdf', '.doc', '.docx', '.txt'];

// Session Storage Keys
export const AUTH_TOKEN_KEY = 'if_auth_token';
export const REDIRECT_AFTER_AUTH_KEY = 'redirect_after_auth';
export const GUEST_SESSION_KEY = 'if_guest_sessions';
export const ONBOARDING_COMPLETE_KEY = 'if_onboarding_complete';

// API Pagination
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

// Timeouts
export const API_TIMEOUT_MS = 30000;
export const TOAST_DURATION_MS = 5000;

// Feature Flags
export const FEATURES = {
  MFA_ENABLED: true,
  GOOGLE_AUTH_ENABLED: true,
  MAGIC_LINK_ENABLED: true,
  GUEST_MODE_ENABLED: true
};
